// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxTalking_container__3gU88","default":"BoxTalking_default__1pIyh","message":"BoxTalking_message__14keH","topSpinner":"BoxTalking_topSpinner__1JKf-"};